import React from "react";
import { ActivityFormCusPreviewContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { userService } from "apiServices";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { ROUTE_PATH } from "utils/constants/routePath";
import { OnlineFormRequestEditItemWidget, HeaderBackHomeWidget } from "widgets";
import { Buttons, Displays, Forms, Navigations } from "components";

class ActivityFormCusPreviewContainer extends React.Component {
  state = {
    isLoading: true,
    activePage: 0,
    step: 1,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const { router } = this.props;
    let resArr = await Promise.all([
      userService.GET_ACTIVITY_FORM_PDPA_DETAIL(router.params?.id),
      router.params?.question_id !== "create"
        ? userService.GET_MY_ACTIVITY_FORM_DETAIL(router.params?.question_id)
        : false,
    ]);
    // ตอน error axios คืน response กลับมา ซึ่ง data เป็น { error: {...} } ไม่ใช่ตัวฟอร์ม
    // ต้องเช็ค question_list ก่อน ไม่งั้น .map() พังตอน draft ถูกลบ/หมดอายุ
    const historyData =
      resArr[1] && Array.isArray(resArr[1]?.data?.question_list)
        ? resArr[1].data
        : null;
    if (resArr && resArr[0].status === 200) {
      if (
        router.params?.question_id !== "create" &&
        !historyData &&
        router.params?.action === "update"
      ) {
        // draft ของ no-member มีอายุ 1 วัน หมดแล้วส่งไม่ได้ ให้ย้อนไปกรอกใหม่
        this.setState({ isLoading: false });
        this.handleExpired();
        return;
      }
      if (historyData) {
        const sortData = {
          ...resArr[0].data,
          question_list: resArr[0].data.question_list.sort(
            (a, b) => a.page - b.page,
          ),
        };
        this.setState({
          initialValue: {
            ...historyData,
            question_list: historyData.question_list.map((e, i) => ({
              ...e,
              questions: e.questions.map((f, j) => {
                let render = f;
                if (f.type === "4") {
                  render.pdpa_details =
                    sortData.question_list[i].questions[j].pdpa_details;
                }
                return render;
              }),
            })),
          },
          data: sortData,
          isLoading: false,
        });
      } else {
        this.setState({
          data: {
            ...resArr[0].data,
            question_list: resArr[0].data.question_list.sort(
              (a, b) => a.page - b.page,
            ),
          },
          isLoading: false,
        });
      }
    }
  };

  handleBack = () => {
    const { activePage, tempValues } = this.state;
    this.setState({
      isLoading: true,
    });
    setTimeout(() => {
      let temp = false;
      let find =
        tempValues &&
        tempValues[activePage - 1].questions.find(
          (e) => e.jumpToBack || e.jumpToBack === 0,
        );
      if (find) {
        temp = find.jumpToBack;
      }
      this.setState({
        activePage: !temp && temp !== 0 ? activePage - 1 : temp,
        isLoading: false,
      });
    }, 500);
  };
  handleSubmit = async (values) => {
    const { activePage, data, tempValues } = this.state;
    const _updateTemp = (masterTempValue, currentValues, jumpToPart) => {
      let temp = masterTempValue;
      const clearData = currentValues.questions.map((e) => {
        let tempValues = e;
        tempValues.is_skip = false;
        delete tempValues.jumpToBack;
        return tempValues;
      });
      if (!temp) {
        temp = [
          {
            title: data.question_list[activePage].title,
            desc: data.question_list[activePage].desc,
            page: data.question_list[activePage].page,
            questions: clearData,
          },
        ];
      } else {
        if (temp[activePage]) {
          temp[activePage] = {
            title: data.question_list[activePage].title,
            desc: data.question_list[activePage].desc,
            page: data.question_list[activePage].page,
            questions: clearData,
          };
        } else {
          temp.push({
            title: data.question_list[activePage].title,
            desc: data.question_list[activePage].desc,
            page: data.question_list[activePage].page,
            questions: clearData,
          });
        }
      }
      if (jumpToPart) {
        for (let index = activePage + 1; index < jumpToPart - 1; index++) {
          if (!temp[index]) {
            temp.push({
              title: data.question_list[index].title,
              desc: data.question_list[index].desc,
              page: data.question_list[index].page,
              questions: data.question_list[index].questions.map((e) => ({
                ...e,
                is_skip: true,
                jumpToBack: activePage,
              })),
            });
          } else {
            temp[index].questions = data.question_list[index].questions.map(
              (e) => ({
                ...e,
                is_skip: true,
                jumpToBack: activePage,
              }),
            );
          }
        }
      }
      return temp;
    };
    // PROCESS
    // =====================================
    // =====================================
    this.setState({
      isLoading: true,
    });
    let findJumpToPart = false;
    if (data.question_list[activePage].jump_to_part) {
      findJumpToPart = data.question_list[activePage].jump_to_part;
    } else {
      let findJumpLv1 = values.questions.find(
        (e) => e.type === "1" && e.answer,
      );
      if (findJumpLv1) {
        let findAns = findJumpLv1.answer_list.find(
          (f) => f.ans === findJumpLv1.answer,
        );
        if (findAns.jump_to_part) {
          findJumpToPart = findAns.jump_to_part;
        }
      }
    }
    setTimeout(() => {
      this.setState({
        tempValues: [..._updateTemp(tempValues, values, findJumpToPart)],
        activePage: !findJumpToPart ? activePage + 1 : findJumpToPart - 1,
        isLoading: false,
      });
    }, 400);
  };

  handlePersonalSubmit = async () => {
    this.setState({
      step: 2,
    });
  };

  // ร่างหมดอายุ/ถูกลบแล้ว พากลับไปหน้าเริ่มกรอกใหม่ (no-member ต้องยืนยัน OTP ใหม่)
  handleExpired = () => {
    const { router } = this.props;
    const locationSplit = router.location.pathname.split("/");
    const isNoMember = !locationSplit.some((e) => e === "system");
    toast.error(
      this.props.t("This form has expired. Please fill it in again.", {
        ns: "activity",
      }),
    );
    this.props.router.navigate(
      `${
        isNoMember ? ROUTE_PATH.ACTIVITY_FORM_NO_LOGIN : ROUTE_PATH.ACTIVITY_FORM
      }/${router.params?.id}/quiz/create/update`,
    );
  };

  handleSentAns = async () => {
    const { router } = this.props;
    const locationSplit = router.location.pathname.split("/");
    const isNoMember = !locationSplit.some((e) => e === "system");
    this.setState({
      isBgLoading: true,
    });
    let params = {
      activity_form_history_id: router.params?.question_id,
    };
    let res = isNoMember
      ? await userService.POST_ACTIVITY_FORM_HISTORY_SENT_ANS_NO_MEMBER(params)
      : await userService.POST_ACTIVITY_FORM_HISTORY_SENT_ANS(params);
    if (res && res.status === 200) {
      toast.success(this.props.t("Submitted successfully", { ns: "common" }));
      this.setState({
        isBgLoading: false,
      });
      this.props.router.navigate(
        `${
          isNoMember
            ? ROUTE_PATH.ACTIVITY_FORM_NO_LOGIN
            : ROUTE_PATH.ACTIVITY_FORM
        }/${router.params?.id}/quiz/${router.params?.question_id}/thank-you`,
      );
    } else {
      this.setState({
        isBgLoading: false,
      });
      // เปิดหน้า preview ค้างไว้ข้ามวันแล้วค่อยกดยืนยัน ร่างหมดอายุไปแล้ว
      if (res?.data?.error?.code === "ACTIVITY_FORM_DRAFT_EXPIRED") {
        this.handleExpired();
      } else {
        toast.error(this.props.t("Submitted failed", { ns: "common" }));
      }
    }
  };

  handleApproveAdminEdit = async (e) => {
    const { router } = this.props;
    this.setState({
      isBgLoading: true,
    });
    let res = await userService.PUT_CUSTOMER_APPROVE_ADMIN_EDIT(
      router.params?.question_id,
    );
    if (res && res.status === 200) {
      this.setState({
        isBgLoading: false,
        isLoading: true,
      });
      toast.success(this.props.t("Approved successfully", { ns: "common" }));
      this.props.router.navigate(
        `${ROUTE_PATH.ACTIVITY_FORM}/${router.params?.id}`,
      );
    } else {
      this.setState({
        isBgLoading: false,
      });
      toast.error(this.props.t("Approved failed", { ns: "common" }));
    }
  };

  render() {
    const { router, t } = this.props;
    const {
      isBgLoading,
      isLoading,
      activePage,
      data,
      initialValue,
      tempValues,
      step,
    } = this.state;
    const renderQuestion = !data
      ? false
      : tempValues && tempValues[activePage]
        ? tempValues[activePage]
        : initialValue && initialValue.question_list.length > 0
          ? initialValue.question_list[activePage]
          : data.question_list[activePage];

    const currentPage = activePage + 1;
    const totalPage = !data ? 0 : data.question_list.length;
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("Activities", { ns: "common" }),
        path: ROUTE_PATH.ACTIVITIES,
      },
    ];
    const locationSplit = router.location.pathname.split("/");
    const isNoMember = !locationSplit.some((e) => e === "system");
    return (
      <ActivityFormCusPreviewContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="header_back_home_layout">
          <HeaderBackHomeWidget />
        </div>
        {isLoading ? (
          <Displays.Loading />
        ) : (
          <div className="body_layout">
            {step === 1 && (
              <>
                {(router.params.action === "check-data" ||
                  router.params.action === "update") && (
                  <div className="title_page">
                    {t("Review Your Information", { ns: "form" })}
                  </div>
                )}
                {!isNoMember && (
                  <div className="header_question_layout">
                    <div className="title">
                      {t("Please fill in the details of the main applicant.", {
                        ns: "activity",
                      })}
                    </div>
                    <div className="desc">
                      {t(
                        "In the case of applying as a group or representative, please fill in the Team leader, parent or teacher.",
                        { ns: "activity" },
                      )}
                    </div>
                  </div>
                )}

                <div className="quiz_container_layout">
                  {isNoMember ? (
                    <Forms.PersonalInfoNoMemberForm
                      isFormDisabled={router.params?.question_id !== "create"}
                      currentPage={activePage + 1}
                      totalPage={data.question_list.length}
                      initialValue={initialValue}
                      onBack={this.handleBack}
                      onSubmit={this.handlePersonalSubmit}
                    />
                  ) : (
                    <Forms.PersonalInfoForm
                      isFormDisabled={router.params?.question_id !== "create"}
                      currentPage={activePage + 1}
                      totalPage={data.question_list.length}
                      initialValue={initialValue}
                      onBack={this.handleBack}
                      onSubmit={this.handlePersonalSubmit}
                    />
                  )}
                </div>
              </>
            )}
            {step === 2 && (
              <>
                {(router.params.action === "check-data" ||
                  router.params.action === "update") && (
                  <div className="title_page">
                    {t("Review Your Information", { ns: "form" })}
                  </div>
                )}
                <div className="header_question_layout">
                  <div className="title">{renderQuestion.title}</div>
                  <div className="desc">{renderQuestion.desc}</div>
                </div>
                <div className="quiz_container_layout">
                  {renderQuestion && (
                    <div className="question_list">
                      {renderQuestion.questions &&
                        renderQuestion.questions.map((f, j) => (
                          <div key={j} className="question_item">
                            <OnlineFormRequestEditItemWidget
                              is_request_edit={
                                router.params.action === "request-edit"
                              }
                              activity_form_history_id={
                                router.params?.question_id
                              }
                              page={renderQuestion.page}
                              {...f}
                              onRequestSuccess={this.fetchData}
                            />
                          </div>
                        ))}
                    </div>
                  )}
                  <div className="f_action_layout">
                    {currentPage > 1 && (
                      <div className="action_item_wrap">
                        <Buttons.BgStandard
                          theme_standard_border
                          label={t("Back", { ns: "common" })}
                          onClick={this.handleBack}
                        />
                      </div>
                    )}
                    {currentPage < totalPage ? (
                      <div className="action_item_wrap">
                        <Buttons.BgStandard
                          label={t("Next", { ns: "common" })}
                          onClick={() => this.handleSubmit(renderQuestion)}
                        />
                      </div>
                    ) : (
                      <div className="action_item_wrap"></div>
                    )}
                  </div>
                  {router.params.action === "update" && (
                    <div className="btn_send_form">
                      <Buttons.BgStandard
                        height="48px"
                        label={t("Confirm and Submit", { ns: "common" })}
                        onClick={this.handleSentAns}
                      />
                    </div>
                  )}
                  {router.params.action === "check-data" && (
                    <div className="btn_send_form">
                      <Buttons.BgStandard
                        height="51px"
                        label={t("Confirm", { ns: "common" })}
                        onClick={this.handleApproveAdminEdit}
                      />
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        )}
      </ActivityFormCusPreviewContainerStyled>
    );
  }
}

export default withTranslation(["common"])(
  withRouter(ActivityFormCusPreviewContainer),
);
